
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 0A5.257 5.257 0 000 5.25c0 3.77 4.891 8.49 5.1 8.689a.217.217 0 00.3 0c.209-.2 5.1-4.92 5.1-8.689A5.257 5.257 0 005.25 0zm0 7.656a2.406 2.406 0 110-4.812 2.406 2.406 0 010 4.812z"}})])
          )
        }
      }
    